<template>
  <div class="entrusted-data-tab">
    <!-- 有托管数据时显示表格 -->
    <div v-if="entrustedData.length > 0">
      <!-- 托管数据表格 -->
      <el-table
        :show-header="false"
        :data="entrustedData"
        style="width: 100%"
        :row-style="{ backgroundColor: '#f9fafb', fontWeight: 'bold' }"
        row-key="id"
      >
        <el-table-column prop="landLocation" label="位置" width="300"></el-table-column>
        <el-table-column prop="totalArea" label="托管总面积" width="300" align="center">
          <template #default="{ row }">
            <span>托管总面积：{{ row.totalArea }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalAmount" label="托管单总金额" align="center">
          <template #default="{ row }">
            <span>托管单总金额：{{ row.totalAmount }}</span>
          </template>
        </el-table-column>

        <!-- 二级表格 -->
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table :data="props.row.details" style="width: 100%">
              <el-table-column prop="contractNo" label="托管单号" width="180" align="center">
                <template slot-scope="scope">
                  <a
                    href="javascript:void(0)"
                    class="contract-number-link"
                    @click="handleContractNoClick(scope.row)"
                  >
                    {{ scope.row.contractNo }}
                  </a>
                </template>
              </el-table-column>
              <el-table-column
                prop="area"
                label="面积(亩)"
                width="150"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="period"
                label="托管期限"
                width="200"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="entrustPerson"
                label="托管人"
                width="180"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="totalPrice"
                label="托管总价(元)"
                align="center"
              ></el-table-column>
            </el-table>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 暂无数据提示 -->
    <div v-else class="empty-data-container">
      <div class="empty-icon">
        <i class="el-icon-s-grid"></i>
      </div>
      <div class="empty-text">暂无托管数据</div>
      <div class="empty-description">当前没有相关的土地托管信息记录</div>
    </div>

    <!-- 托管详情弹窗 -->
    <EntrustedDetailDialog
      :visible.sync="entrustedDetailDialogVisible"
      :contractNo="selectedContractNo"
      :orderId="selectedOrderId"
    />
  </div>
</template>

<script>
import EntrustedDetailDialog from './EntrustedDetailDialog.vue'

export default {
  name: 'EntrustedDataTab',
  components: {
    EntrustedDetailDialog
  },
  props: {
    entrustedInfoList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // 托管详情对话框控制
      entrustedDetailDialogVisible: false,
      selectedContractNo: '',
      selectedOrderId: '',

      // 托管数据表格数据
      _entrustedData: [
        {
          id: 1,
          landLocation: '华东区一号地块',
          totalArea: '500亩',
          totalAmount: '250000元',
          details: [
            {
              orderId: 'HT202406006',
              contractNo: 'HT202406001',
              area: 200,
              period: '2024-01-15至2025-01-15',
              entrustPerson: '张三',
              totalPrice: 120000
            },
            {
              orderId: 'HT202406006',
              contractNo: 'HT202406004',
              area: 300,
              period: '2024-01-20至2025-01-20',
              entrustPerson: '赵六',
              totalPrice: 130000
            }
          ]
        },
        {
          id: 2,
          landLocation: '华东区二号地块',
          totalArea: '450亩',
          totalAmount: '225000元',
          details: [
            {
              orderId: 'HT202406006',
              contractNo: 'HT202406002',
              area: 150,
              period: '2024-02-20至2025-02-20',
              entrustPerson: '李四',
              totalPrice: 75000
            },
            {
              orderId: 'HT202406006',
              contractNo: 'HT202406005',
              area: 300,
              period: '2024-02-25至2025-02-25',
              entrustPerson: '孙七',
              totalPrice: 150000
            }
          ]
        },
        {
          id: 3,
          landLocation: '华中区一号地块',
          totalArea: '350亩',
          totalAmount: '175000元',
          details: [
            {
              orderId: 'HT202406006',
              contractNo: 'HT202406003',
              area: 180,
              period: '2024-03-10至2025-03-10',
              entrustPerson: '王五',
              totalPrice: 90000
            },
            {
              orderId: 'HT202406006',
              contractNo: 'HT202406006',
              area: 170,
              period: '2024-03-15至2025-03-15',
              entrustPerson: '周八',
              totalPrice: 85000
            }
          ]
        }
      ]
    }
  },
  computed: {
    entrustedData() {
      return this.mapToEntrustedData(this.entrustedInfoList)
    }
  },
  methods: {
    // 处理合同编号点击
    handleContractNoClick(row) {
      console.log('点击了托管单号:', row.contractNo)
      this.selectedContractNo = row.contractNo
      this.selectedOrderId = row.orderId || ''
      this.entrustedDetailDialogVisible = true
    },

    mapToEntrustedData(data) {
      return data.map(item => ({
        id: item.areaCode || '', // 地区编号作为唯一标识
        landLocation: item.areaName || '', // 地区名
        totalArea: `${item.totalLandArea.toFixed(2) || 0}亩`, // 总托管面积
        totalAmount: `${item.totalPrice || 0}元`, // 总价格
        details: this.mapToTrusteeItems(item.trusteeItemList || []) // 托管单列表
      }))
    },

    // 映射托管单详情列表
    mapToTrusteeItems(trusteeItems) {
      return trusteeItems.map(item => ({
        orderId: item.orderId || '', // 托管单ID
        contractNo: item.orderCode || '', // 托管单号
        area: item.landArea.toFixed(4) || 0, // 托管面积
        period: item.trusteePeriod, // 托管期限
        entrustPerson: item.companyName || '', // 托管人
        totalPrice: item.price || 0 // 托管价格
      }))
    },

  }
}
</script>

<style lang="less" scoped>
.entrusted-data-tab {
  width: 100%;
  height: 100%;
  min-height: 160px;
}

.contract-number-link {
  color: #1890ff;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #40a9ff;
    text-decoration: underline;
  }
}

.empty-data-container {
  text-align: center;
  padding: 20px 20px;

  .empty-icon {
    margin-bottom: 16px;
    
    i {
      font-size: 48px;
      color: #d9d9d9;
      transition: all 0.3s ease;
      
      &:hover {
        color: #bfbfbf;
        transform: scale(1.05);
      }
    }
  }

  .empty-text {
    font-size: 16px;
    font-weight: 500;
    color: #595959;
    margin-bottom: 6px;
    line-height: 1.4;
  }

  .empty-description {
    font-size: 13px;
    color: #8c8c8c;
    line-height: 1.5;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .empty-data-container {
    padding: 15px 15px;
    
    .empty-icon i {
      font-size: 36px;
    }
    
    .empty-text {
      font-size: 14px;
    }
    
    .empty-description {
      font-size: 12px;
    }
  }
}
</style>
